import { defineMessages } from 'react-intl';

export const skillTranslations = defineMessages({
    atLeastOne: {
        id: 'Skills.form.validation.atLeastOne',
        defaultMessage: 'Select at least one skill.'
    }
});
